module.exports = __webpack_public_path__ + "img/02-thumb.893de941.png";